import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { Branch } from "../../../../../../../Wrap/Models/Models/Company/Branch";
import { ValidatorContents } from "../../../../../../Dashboard/Common/ValidatorHelper";
import { Email } from "../../../../../../../react-core/Html/Validation/RegExPatterns";

interface IBranchDetailProps extends React.Props<BranchDetail> {
    isReview?: boolean;
    data: Branch;
    onChange: (changes) => void;
    onRef: (ref) => void;
}

interface IBranchDetailState {}

export class BranchDetail extends FormComponent<IBranchDetailProps, IBranchDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { data, isReview } = this.props;
        return (
            <>
                {SectionHeader("Branch")}
                <TextBoxEditor
                    label="Branch name:*"
                    required="Please enter branch name"
                    value={data.BranchName}
                    disabled={isReview}
                    onChange={(v) => this.props.onChange({ BranchName: v })}
                />
                <TextBoxEditor
                    label="Email address:*"
                    required="Please enter email address"
                    value={data.Email.Value}
                    disabled={isReview}
                    regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                    onChange={(v) => this.props.onChange({ Email: { Value: v } })}
                />
            </>
        );
    }
}
